import { LitElement, css, html } from 'lit';
import { customElement, property, query } from 'lit/decorators';

import { Fab } from '@material/mwc-fab';
import topicData from '../helpers/state/topic-data';

type ButtonMode = 'hidden' | 'fab' | 'text';

@customElement('active-challenge-button')
export class ActiveChallengeButton extends LitElement {
    amplitude_callsite: string = 'Active Challenge';

    @query('#activeChallengeButton')
    activeChallengeButton!: Fab;

    @property({ type: String })
    buttonMode: ButtonMode = 'text';

    openChallengeModal() {
        this.dispatchEvent(new CustomEvent('open-challenge'));
    }

    private renderTextButton() {
        return html`
            <button @click=${this.openChallengeModal} class="challenge-button--text">
                <mwc-icon class="challenge-button--text-icon">add_location</mwc-icon>
                Add ${topicData.topic?.point_name ?? 'Point'}
            </button>`;
    }

    onMouseEnter() {
        this.dispatchEvent(new CustomEvent('on-mouseenter', { detail: { button: this.activeChallengeButton }}));
    }

    onMouseLeave() {
        this.dispatchEvent(new CustomEvent('on-mouseleave', { detail: { button: this.activeChallengeButton }}));
    }

    private renderFabButton() {
        return html`<mwc-fab
                        class="challenge-button--icon"
                        mini
                        id="activeChallengeButton"
                        icon="star_outline"
                        @mouseenter="${this.onMouseEnter}"
                        @mouseleave="${this.onMouseLeave}"
                        @click="${this.openChallengeModal}"
                        label="Challenge">
                    </mwc-fab>`;
    }

    protected render() {
        return html`
            ${this.buttonMode === 'text' ?
                this.renderTextButton()
            : ''}

            ${this.buttonMode === 'fab' ?
                this.renderFabButton()
            :''}
        `;
    }

    static get styles() {
        return css`
            .challenge-button--text {
                display: flex;
                flex-direction: column;
                align-items: center;
                color: var(--theme-input-color);
                width: 80px;
                background-color: var(--main-featured-color);
                border-top-right-radius: 8px;
                border-bottom-right-radius: 8px;
                border: 0;
                margin: 10px 0;
                padding: 8px;
                cursor: pointer;
                box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
            }

            .challenge-button--text-icon {
                padding-bottom: 4px;
            }

            .challenge-button--icon {
                --mdc-theme-secondary: var(--main-invalid-color) !important;
                --mdc-theme-on-secondary: var(--theme-white-color) !important;
            }
        `;
    }
}
